import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UserService } from "../services/UserService";

export default function AuthMiddleware({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const userService = new UserService();

    const checkAuth = async () => {
      // Ignora a verificação para rotas específicas
      if (
        location.pathname === "/login" ||
        location.pathname === "/termos-de-uso"
      ) {
        return;
      }

      try {
        // Tenta buscar o usuário autenticado
        await userService.find();
      } catch (error) {
        console.error("Token inválido ou expirado. Redirecionando para login.");
        localStorage.removeItem("authToken"); // Remove o token inválido
        // navigate("/login"); // Redireciona para login
        window.location.href = "/login";
      }
    };

    checkAuth();
  }, [location.pathname, navigate]);

  return children;
}
